import { render, staticRenderFns } from "./UserDialog.vue?vue&type=template&id=9bd4fb8e&scoped=true"
import script from "./UserDialog.vue?vue&type=script&lang=js"
export * from "./UserDialog.vue?vue&type=script&lang=js"
import style0 from "./UserDialog.vue?vue&type=style&index=0&id=9bd4fb8e&prod&scoped=true&lang=scss"
import style1 from "./UserDialog.vue?vue&type=style&index=1&id=9bd4fb8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bd4fb8e",
  null
  
)

export default component.exports